import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ModalFourContent = () => {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
  };
  return (
      <div className="slideshow">
        <figure>
          {/* Project Details Starts */}
          <figcaption>
            <h3>Premiumspace</h3>
            <div className="row open-sans-font">
              <div className="col-12 col-sm-6 mb-2">
                <i className="fa fa-file-text-o pr-2"></i>
                <span className="project-label">Проект </span>:{" "}
                <span className="ft-wt-600 uppercase">CRM система</span>
              </div>
              {/* End .col */}

              <div className="col-12 col-sm-6 mb-2">
                <i className="fa fa-user-o pr-2"></i>
                <span className="project-label">Клієнт </span>:{" "}
                <span className="ft-wt-600 uppercase">Бюро перекладів</span>
              </div>
              {/* End .col */}

              <div className="col-12 col-sm-6 mb-2">
                <i className="fa fa-code pr-2"></i>
                <span className="project-label">CMS </span>:{" "}
                <span className="ft-wt-600 uppercase">Власна</span>
              </div>
              {/* End .col */}

              <div className="col-12 col-sm-6 mb-2">
                <i className="fa fa-external-link pr-2"></i>
                <span className="project-label">Сайт </span>:{" "}
                <span className="ft-wt-600 uppercase">
                  <a href="https://movasvit.com" target="_blank" rel="noreferrer">Movasvit</a>
                </span>
              </div>
              {/* End .col */}
            </div>
            {/* End .row */}
          </figcaption>
          {/* Project Details Ends */}

          {/*  Main Project Content Starts */}
          <Slider {...settings}>
            <div className="slide_item">
              <img src="img/projects/project-4_1.webp" alt="slide 1"/>
            </div>
            <div className="slide_item">
              <img src="img/projects/project-4_2.webp" alt="slide 2"/>
            </div>
            <div className="slide_item">
              <img src="img/projects/project-4_3.webp" alt="slide 3"/>
            </div>
            <div className="slide_item">
              <img src="img/projects/project-4_4.webp" alt="slide 4"/>
            </div>
            <div className="slide_item">
              <img src="img/projects/project-4_5.webp" alt="slide 5"/>
            </div>
          </Slider>
          {/* Main Project Content Ends */}

          {/* Project Description Content Starts */}
          <div className="project_description">
            <h4>Опис проекту</h4>
            <p>Замовник - бюро міжнародних перекладів. Для обліку та планування робіт, власнику знадобилась CRM система обліку. Було вирішено створити власну унітарну систему з можливостями подальшого розширення. В даній системі ведеться облік клієнтів, виконавців та інших учасників процесу. Проект відповідає усім вимогам замовника. На виконання проекти витрачено 3 місяці. Роботу над системою веду і досі.</p>
          </div>
          {/* Project Description Content Ends */}

        </figure>
      </div>
      //  End .slideshow
  );
};

export default ModalFourContent;
